export const namespaced = true;

export const state = {
  trialTeachingMaterials: [
    {
      productCode: '10',
      teachingMaterialCode: '400',
      id: 1,
      code: 'kiwami_trial',
      name: '図形の極 体験版',
    },
    {
      productCode: '10',
      teachingMaterialCode: '400',
      id: 2,
      code: 'kiwami_trialJr',
      name: '図形の極 体験版Jr.',
    },
    {
      productCode: '10',
      teachingMaterialCode: '400',
      id: 3,
      code: 'kiwami_trial_trialJr',
      name: '図形の極 体験版 / 体験版Jr.',
    },
    {
      productCode: '40',
      teachingMaterialCode: '700',
      id: 4,
      code: 'kokugo_trialG1',
      name: '魔法の国語 体験版Grade1',
    },
    {
      productCode: '40',
      teachingMaterialCode: '700',
      id: 5,
      code: 'kokugo_trialG2',
      name: '魔法の国語 体験版Grade2',
    },
    {
      productCode: '40',
      teachingMaterialCode: '700',
      id: 6,
      code: 'kokugo_trialG3',
      name: '魔法の国語 体験版Grade3',
    },
    {
      productCode: '40',
      teachingMaterialCode: '700',
      id: 7,
      code: 'kokugo_trialG4',
      name: '魔法の国語 体験版Grade4',
    },
    {
      productCode: '40',
      teachingMaterialCode: '700',
      id: 8,
      code: 'kokugo_trialG1_summer',
      name: '魔法の国語 G1 夏バージョン',
    },
    {
      productCode: '40',
      teachingMaterialCode: '700',
      id: 9,
      code: 'kokugo_trialG2_summer',
      name: '魔法の国語 G2 夏バージョン',
    },
    {
      productCode: '40',
      teachingMaterialCode: '700',
      id: 10,
      code: 'kokugo_trialG3_summer',
      name: '魔法の国語 G3 夏バージョン',
    },
    {
      productCode: '40',
      teachingMaterialCode: '700',
      id: 11,
      code: 'kokugo_trialG4_summer',
      name: '魔法の国語 G4 夏バージョン',
    },
    {
      teachingMaterialCode: '400',
      id: 12,
      code: 'trialCode',
      name: '専用体験コードを入力（お持ちの方のみ）',
    },
  ],
};

export const getters = {
  getTrialTeachingMaterialById: (state) => (id) => {
    return state.trialTeachingMaterials.find((item) => item.id == id);
  },
  getTrialTeachingMaterialByCode: (state) => (code) => {
    return state.trialTeachingMaterials.find((item) => item.code == code);
  },
};
